import html2canvas from "html2canvas";

// fields: [
//   {
//     title: "A short field's title",
//     value: "A short field's value",
//   },
// ],
const sendSlackMessage = (message, fields = [], withImage = false) => {
  if (withImage) {
    html2canvas(document.getElementsByTagName("body")[0], { scale: 0.2 }).then(function (canvas) {
      const image = canvas.toDataURL();
      const payload = {
        attachments: [
          {
            mrkdwn_in: ["text"],
            color: "#36a64f",
            pretext: window.location.href,
            title: "Error Report",
            text: message,
            fields,
          },
          {
            text: "Click to View Image",
            fallback: "Click to View Image",
            callback_id: "Click_to_View_Image",
            color: "#ff28cd",
            attachment_type: "default",
            actions: [
              {
                text: "View ScreenShot",
                type: "button",
                url: image,
              },
            ],
          },
        ],
      };

      fetch("https://hooks.slack.com/services/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", {
        method: "POST",
        redirect: "follow",
        mode: "cors",
        body: JSON.stringify(payload),
      }).finally((_) => {});
    });
  } else {
    const payload = {
      attachments: [
        {
          mrkdwn_in: ["text"],
          color: "#36a64f",
          pretext: window.location.href,
          title: "Error Report",
          text: message,
          fields,
        },
      ],
    };
    fetch("https://hooks.slack.com/services/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", {
      method: "POST",
      redirect: "follow",
      mode: "cors",
      body: JSON.stringify(payload),
    }).finally((_) => {});
  }
};

const sentApiError = (fields) => {
  const payload = {
    attachments: [
      {
        mrkdwn_in: ["text"],
        color: "#36a64f",
        pretext: window.location.href,
        title: "API ERROR",
        text: `UserId:[${window.login_user_id}] | SiteId:[${window.current_site_id}] | TeamId:[${window.team_id}] | IsTester:[${window.is_user_tester}]`,
        fields,
      },
    ],
  };
  fetch("https://hooks.slack.com/services/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", {
    method: "POST",
    redirect: "follow",
    mode: "cors",
    body: JSON.stringify(payload, undefined, 2),
  })
    .catch((_) => {})
    .finally((_) => {});
};

export { sendSlackMessage, sentApiError };
